<template>
  <Drawer v-model="openDrawer" title="历史进程" width="300">
    <Steps :current="0" direction="vertical" id="absec" v-if="openDrawer">
      <Step
        :icon="index==0?'md-alarm':'md-arrow-up'"
        v-for="(x, index) in steps"
        :key="index"
        :title="x.currNodeName"
        >
        <template slot='title'>[{{x.currNodeName}}] {{x.auditorUser}}</template>
        <ly-form-item slot="content" label="节点动作">
          [{{x.nodeName}}] {{x.addUser }} {{ x.lineName }}
        </ly-form-item>
        <ly-form-item slot="content" label="收到意见">
          {{ x.content }} </ly-form-item
        >
        <ly-form-item slot="content" label="收到时间">
          {{ utils.time(x.lasttime) }}
        </ly-form-item>
        <ly-form-item slot="content" label="收到图片">
          <viewer>
            <img
              v-for="(y, index1) in x.afterImgList"
              :key="index1"
              :src="axios.platConfig.fileUri + y"
              width="24"
              height="24"
              style="margin-right: 4px; cursor: pointer"
            />
          </viewer>
        </ly-form-item>
      </Step>
    </Steps>
  </Drawer>
</template>
<script>
export default {
  data() {
    return {
      openDrawer: false,
      steps: [],
      searchItem: {
        //pageNumber: 1,
        //pageSize: 50,
        flowId: "",
        flowStartId: "",
        //keyWork: "",
      },
    };
  },
  methods: {
    reach(v) {
      this.openDrawer = true;
      this.searchItem.flowId = v.flowId;
      this.searchItem.flowStartId = v.flowStartId;
      this.getList();
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/flow/nodeList",
        data: this.searchItem,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList.filter(function(item){
          return item.nodeType==1
        });

        for (let i = 0; i < data.length; i++) {
          data[i].beforeImgList = this.utils.isEmpty(data[i].beforeImg)
            ? []
            : data[i].beforeImg.split(",");
          data[i].afterImgList = this.utils.isEmpty(data[i].afterImg)
            ? []
            : data[i].afterImg.split(",");
        }

        this.steps = data;
      });
    },
  },
};
</script>
<style lang="">
#absec .ivu-steps-item.ivu-steps-status-wait .ivu-steps-title {
  color: #333;
}
#absec .ivu-steps-item.ivu-steps-status-wait .ivu-steps-head-inner span,
#absec
  .ivu-steps-item.ivu-steps-status-wait
  .ivu-steps-head-inner
  > .ivu-steps-icon {
  color: #2d8cf0;
}
#absec .ivu-steps-item.ivu-steps-status-wait .ivu-steps-content {
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/yhgl/jincheng.vue